import React from "react";

interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
  isDisabled?: boolean;
  title?: string;
  isAvailable?: boolean;
}

const TabButton: React.FC<TabButtonProps> = ({
  label,
  isActive,
  onClick,
  isDisabled = false,
  title = "",
  isAvailable = true
}) => {
  const getClassName = () => {
    const baseClass = "px-4 py-2 font-medium text-sm";
    if (isActive) return `${baseClass} text-primary-600 border-b-2 border-primary-600`;
    if (!isAvailable) return `${baseClass} text-neutral-300 dark:text-neutral-600 cursor-not-allowed`;
    return `${baseClass} text-neutral-500 hover:text-neutral-900 dark:text-neutral-400 dark:hover:text-neutral-100`;
  };

  return (
    <button
      className={getClassName()}
      onClick={onClick}
      disabled={isDisabled}
      title={title}
    >
      {label}
    </button>
  );
};

export default TabButton;
export type { TabButtonProps };
